import * as React from 'react';
import { Badge } from 'reactstrap';
import { VirtualLogCollector } from '../../../types';
import { TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE } from '../../../widgets/LightTooltip';
import Icon, { IconType } from '../../../widgets/Icons';
import { Tooltip } from '@rtkwlf/fenrir-react';

type StatusInfo = {
  label: string;
  tooltip: string;
  color: string;
  icon: IconType;
};

const STATUS_INFO: Record<VirtualLogCollector['state'], StatusInfo> = {
  registered: {
    label: 'Activated',
    tooltip: '<type> is activated and ready to provide insights to your CST.',
    icon: Icon.Check,
    color: 'success',
  },
  activated: {
    label: 'Not activated',
    tooltip: '<type> is installed and is awaiting activation.',
    icon: Icon.Prohibited,
    color: 'unknown',
  },
};

export const ColumnStatus: React.FunctionComponent<{
  state: VirtualLogCollector['state'];
  productType?: VirtualLogCollector['product_type'];
  isVanilla?: VirtualLogCollector['is_vanilla'];
}> = ({ state, productType, isVanilla }) => {
  const { label, color, icon: StatusIcon, tooltip } = STATUS_INFO[state];
  const type =
    productType?.toLowerCase() === 'vsensor'
      ? 'Virtual sensor'
      : productType?.toLowerCase() === 'vlc'
      ? 'Virtual log collector'
      : isVanilla
      ? 'Physical appliance'
      : 'Virtual appliance';
  return (
    <Tooltip.Root delayDuration={TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE.show}>
      <Tooltip.Trigger asChild>
        <div className="d-inline-block">
          <Badge color={color} className="status-badge cursor-question">
            <StatusIcon size={14} className="mr-2" />
            {label}
          </Badge>
        </div>
      </Tooltip.Trigger>
      <Tooltip.Content side={'top'}>
        <Tooltip.Text>{tooltip.replace('<type>', type)}</Tooltip.Text>
      </Tooltip.Content>
    </Tooltip.Root>
  );
};
